import { useState, useCallback, useEffect } from 'react';
import throttle from 'lodash/throttle';

export function useScrollToTop(containerRef, threshold = 20, isEnabled = true) {
  const [showScrollTop, setShowScrollTop] = useState(false);

  const handleScroll = useCallback(
    throttle(() => {
      if (isEnabled && containerRef?.current) {
        const scrollTop = containerRef.current.scrollTop;
        const shouldShow = scrollTop > threshold;
        setShowScrollTop(shouldShow);
      } else {
        setShowScrollTop(false);
      }
    }, 100),
    [threshold, isEnabled],
  );

  const scrollToTop = useCallback(() => {
    if (isEnabled && containerRef?.current) {
      containerRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [isEnabled]);

  useEffect(() => {
    const currentRef = containerRef?.current;

    // Reset state when isEnabled changes
    if (!isEnabled) {
      setShowScrollTop(false);
    }

    if (isEnabled && currentRef) {
      currentRef.addEventListener("scroll", handleScroll, {
        passive: true,
      });

      handleScroll();

      return () => {
        currentRef.removeEventListener("scroll", handleScroll);
      };
    }
  }, [handleScroll, containerRef, isEnabled]);

  return { showScrollTop, scrollToTop };
}